/**
 * THE MAGTEK DynaFlex II FORM RULES for the SUNMI register/edit modal.
 *
 * A MagTek reader row is a pool row only (`deviceClass: 'magtek_usb'`): name,
 * model (PED / Go — the model decides the reader kind) and the sticker serial.
 * It carries NO secret — the till authorises with the LOCATION's UniGate
 * credentials (written by pos-magtek-service/scripts/set-unigate-creds.mjs,
 * shown here only as Set / Missing).
 *
 * Writes use the existing routes only:
 *   register → POST …/emv-devices { paymentConfigId: 'magtek_usb', deviceName, model, serialNumber }
 *   edit     → PATCH …/emv-devices/{id} { deviceName } | { deviceConfig: { serialNumber } } | { magtekModel }
 */
import { MAGTEK_CLASS, MAGTEK_KIND_BY_MODEL } from './cardSetupModel';

export const MAGTEK_MODELS = [
  { id: 'MagTek DynaFlex II PED', label: 'DynaFlex II PED', sub: 'Screen + PIN pad' },
  { id: 'MagTek DynaFlex II Go', label: 'DynaFlex II Go', sub: 'No screen' },
] as const;

export interface MForm { deviceName: string; model: string; serial: string }

export const isMagtekDevice = (d: any) => String(d?.deviceClass || '') === MAGTEK_CLASS;

export function magtekFormFromDevice(d: any): MForm {
  return { deviceName: d?.deviceName || '', model: d?.model || '', serial: d?.serialNumber || '' };
}

/** Problems keyed by field — empty object = valid. */
export function magtekProblems(f: MForm): Partial<Record<keyof MForm, string>> {
  const out: Partial<Record<keyof MForm, string>> = {};
  if (!f.deviceName.trim()) out.deviceName = 'Required';
  if (!MAGTEK_KIND_BY_MODEL[f.model]) out.model = 'Pick the model';
  if (!f.serial.trim()) out.serial = 'Required';
  return out;
}

export function magtekRegisterBody(f: MForm) {
  return { paymentConfigId: MAGTEK_CLASS, deviceName: f.deviceName.trim(), model: f.model, serialNumber: f.serial.trim() };
}

/** The edit requests — changed fields only, one route each. */
export function magtekEditPatches(device: any, f: MForm): Array<Record<string, unknown>> {
  const base = magtekFormFromDevice(device);
  const out: Array<Record<string, unknown>> = [];
  if (f.deviceName.trim() && f.deviceName.trim() !== base.deviceName) out.push({ deviceName: f.deviceName.trim() });
  if (f.serial.trim() && f.serial.trim() !== base.serial) out.push({ deviceConfig: { serialNumber: f.serial.trim() } });
  if (f.model && f.model !== base.model) out.push({ magtekModel: f.model });
  return out;
}
